import { render, staticRenderFns } from "./DeliveryTypeEdit.vue?vue&type=template&id=4f0986e0&"
import script from "./DeliveryTypeEdit.vue?vue&type=script&lang=js&"
export * from "./DeliveryTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports